import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ExpertiseModalDetailComponent } from './modal/expertise-modal-detail/expertise-modal-detail.component';
import { ExpertiseModalAjoutComponent } from './modal/expertise-modal-ajout/expertise-modal-ajout.component';
import { ListExpertiseComponent } from './list-expertise/list-expertise.component';
import { FilterExpertiseByNamePipe } from 'src/app/shared/pipes/filter-expertise-by-name/filter-expertise-by-name.pipe';

@NgModule({
	declarations: [
		ListExpertiseComponent,
		ExpertiseModalDetailComponent,
		ExpertiseModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterExpertiseByNamePipe]
})

export class ExpertiseModule {}
